import * as React from 'react';
import { ComponentProps, ButtonSecondary, Validation, ValidationLevel, ValidationProps } from 'ui';
import { NavigateToNewDraftInjectedProps, withNavigateToNewDraft } from 'app/area/case/components/enhancers/navigate-to-new-draft';
import { containerFactory } from 'app/infrastructure/redux/container-factory';
import { actionCreators } from 'app/area/case/draft/actions';
import { STATE } from 'app/constants';
import styles from './add-new-case-button.scss';

interface AddNewCaseButtonProps extends ComponentProps, NavigateToNewDraftInjectedProps {
  readOnly?: boolean;
  validation?: ValidationProps;
  textSavingInfo: string;
}

class AddNewCaseButtonComponent extends React.PureComponent<AddNewCaseButtonProps> {
  public static statePath: string = STATE.app;

  public render() {
    const {
      componentId,
      className,
      label,
      readOnly,
      validation
    } = this.props;

    const {
      buttonWrapper
    } = styles;

    const errorParams = {
      level: ValidationLevel.error,
      messages: [{level: ValidationLevel.error,
                  message: validation && validation.messages && validation.messages.map(m=>`${m.label}: ${m.message}`).join('\n')}]
    };

    const hasValidationErrors = (validation && !!validation.messages.length);
    const validationErrorStyle = hasValidationErrors && styles.validationError;

    return (
      readOnly ? null :
      <div id={componentId} className={`${styles.buttonContainer} ${className}`}>
        <div  className={`${buttonWrapper} ${className}`}>
          <ButtonSecondary id={`${componentId}-button`} classNames={validationErrorStyle} onClick={this.props.navigateToNewDraft}>
            {label && label.required && <span className="asterisk-required">* </span>}
            {label && label.text}
          </ButtonSecondary>
          {validation && <Validation {...errorParams}/>}
        </div>
      </div>
    );
  }
}

const c = containerFactory(withNavigateToNewDraft(AddNewCaseButtonComponent), actionCreators, undefined);

export { c as AddNewCaseButton };
